import { Suspense } from 'react';
import { withTranslation } from "react-i18next";
import './App.css';
import './breadcrumb.css';
import Spinner from './components/Spinner';
import { ContactUsPage } from './views/ContactUs/';
import IdentificationForm from './views/IdentificationForm';
import Passport from './views/Passport';
import SearchView from './views/SearchView';
import StandaloneFinder from './views/StandaloneFinder';
import Visualization from './views/Visualization';
import { Workflow } from './views/Workflow';

const appMapping = {
  "workflow": Workflow,
  "passport": Passport,
  "visualization": Visualization,
  "finder": StandaloneFinder,
  "identification_form": IdentificationForm,
  "search": SearchView,
  "contactUs": ContactUsPage,
};

function App() {
  const appName = document.querySelector("#root").getAttribute("app");
  const AppClass = withTranslation()(appMapping[appName]);

  return <Suspense fallback={<Spinner style={{ minHeight: "70vh", alignItems: "center" }} />}>
    <AppClass />
  </ Suspense >;
}

export default App;
